export const selectEmployerTemplateState = (state) => state.employerTemplate;
